import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "../Home/Home";
import Help from "../Help/Help";
import PhotoRequest from "../Photo/PhotoRequest";
import VideoRequest from "../Video/VideoRequest";
import SpiritRequest from "../Spirit/SpiritRequest";
import FacilitiesRequest from "../Facilities/FacilitiesRequest";
import NotFound from "../NotFound/NotFound";
import SiteNav from "../Shared/Nav/SiteNav";
import LogPageView from "../Shared/LogPageView/LogPageView";

class Routes extends React.Component {
  render() {
    return (
      <Router>
        <div>
          <SiteNav />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/photo" component={PhotoRequest} />
            <Route exact path="/video" component={VideoRequest} />
            <Route exact path="/spirit" component={SpiritRequest} />
            <Route exact path="/facilities" component={FacilitiesRequest} />
            <Route exact path="/help" component={Help} />
            <Route component={NotFound} />
          </Switch>
          <Route component={LogPageView} />
        </div>
      </Router>
    );
  }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js